import { io } from 'socket.io-client';
import { V2_BASE_URL } from './utils/constants';

const socket = io(V2_BASE_URL, {
  transports: ['websocket'],
  autoConnect: false,
});

socket.on('connect', () => {
  console.log('socket id : ', socket.id);
  if (sessionStorage.getItem('user')) {
    const user_info = JSON.parse(sessionStorage.getItem('user') as string);
    if (socket.id && user_info) {
      socket.emit('joinRoom', user_info);
    }
  }
});
socket.on('joinRoomRes', res => {
  console.log(res);
});
socket.on('disconnect', () => {
  console.log('socket id : ', socket.id); // undefined
});

export default socket;
